module.exports = __webpack_public_path__ + "img/John-Price.7aeae58b.png";